// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveFilterPill_root__YQQ3F"};